import React, { useEffect, useState } from 'react';
import { Patent } from '../interfaces/prof/PatentInterface';
import './publication.css';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';


const PatentList: React.FC = () => {
    const [data, setData] = useState<Patent[]>([]);
    const [groupedData, setGroupedData] = useState<{[key: string]: Patent[]}>({});
    const API_BASE_URL = 'http://220.69.209.170:3333';

    const fetchAPI = async (endpoint: string) => {
        try {
            const response = await fetch(`${API_BASE_URL}${endpoint}`);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchAPI('/patent/getPatentList');
    }, []);

    useEffect(() => {
        const grouped = data.reduce((acc, patent) => {
            const year = patent.date.substring(0, 4); // 연도 앞 4자리 추출
            if (!acc[year]) {
                acc[year] = [];
            }
            acc[year].push(patent);
            return acc;
        }, {} as {[key: string]: Patent[]});

        setGroupedData(grouped);
    }, [data]);

    return (        
        <div>
            {Object.keys(groupedData).sort().reverse().map((year) => (
                <div key={year} className="yearSection">
                    <h3 className="yearTitle"><CalendarTodayIcon />{   year}</h3>
                    <ul className="publicationList">                    
                        {groupedData[year].map((patent, index) => (                            
                            <li key={index} className="publicationItem">                               
                                ■ <b> "{patent.title}", {patent.number}, {patent.date} {patent.registration === "application" ? " [등록]" : " [출원]"} </b><br></br>                                                                
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}

export default PatentList;
